import { ZodiosHooks } from "@alex-mcgovern/zodios-react";

import { pluginError } from "@shared/zodios";

import { createApiClient } from "./schemas";

export const client = createApiClient(import.meta.env.VITE_FUSE_API_BASE_URL, {
	axiosConfig: {
		withCredentials: true,
	},
	validate: "request",
});

client.use(pluginError());

export const queryClient = new ZodiosHooks("fuseInternalApi", client);

// This client (without the plugin) is used to fetch the user info for the auth context
const authClient = createApiClient(import.meta.env.VITE_FUSE_API_BASE_URL, {
	axiosConfig: {
		withCredentials: true,
	},
	validate: "request",
});
export const authQueryClient = new ZodiosHooks("fuseInternalApi", authClient);
